export const USER_LOGIN_LOADING = "USER_LOGIN_LOADING";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILED = "USER_LOGIN_FAILED";
export const USER_LOGIN_RESET = "USER_LOGIN_RESET";

export const USER_REGISTER_LOADING = "USER_REGISTER_LOADING";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAILED = "USER_REGISTER_FAILED";
export const USER_REGISTER_RESET = "USER_REGISTER_RESET";

export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_LOADING = "USER_LOGOUT_LOADING";
export const USER_LOGOUT_FAILED = "USER_LOGOUT_FAILED";

export const USER_PROFILE_UPDATE_LOADING = "USER_PROFILE_UPDATE_LOADING";
export const USER_PROFILE_UPDATE_SUCCESS = "USER_PROFILE_UPDATE_SUCCESS";
export const USER_PROFILE_UPDATE_FAILED = "USER_PROFILE_UPDATE_FAILED";
export const USER_PROFILE_UPDATE_RESET = "USER_PROFILE_UPDATE_RESET";

// export const GET_CURRENT_USER_LOADING = "GET_CURRENT_USER_LOADING";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAILED = "GET_CURRENT_USER_FAILED";
